// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Employees
export const getServiceEmployeesList = createAsyncThunk('appServiceEmployee/getServiceEmployeesList', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1    
    const response = await axios.post(apiLink('getServiceEmployees'), params)    
    
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }
})
// ** Get short list only fn,ln,id
export const getServiceEmployeesListShort = createAsyncThunk('appServiceEmployee/getServiceEmployeesListShort', async () => {   
    const response = await axios.post(`https://api.mfauto.com.ua/repair/employee-list?env=${process.env.REACT_APP_NODE_ENV}`, {
        token: localStorage.getItem('token')
    })
    return response.data
})
export const addServiceEmployee = createAsyncThunk('appServiceEmployee/addStation', async (data) => {
    const response = await axios.post(apiLink('addServiceEmployee'), data)
    return response.data
})
export const updateServiceEmployee = createAsyncThunk('appServiceEmployee/updateServiceEmployee', async (data) => {
    const response = await axios.put(apiLink({name: 'updateServiceEmployee', value: data.id}), data)
    return response.data
})
export const getServiceEmployee = createAsyncThunk('appServiceEmployee/getServiceEmployee', async (id) => {
    const response = await axios.get(apiLink({name: 'getServiceEmployee', value: id}))
    return response.data
})
export const removeServiceEmployee = createAsyncThunk('appServiceEmployee/removeServiceEmployee', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeServiceEmployee', value: id}))
    return response.data
})

// ** Employee roles
export const getServiceEmployeeRoles = createAsyncThunk('appServiceEmployee/getServiceEmployeeRoles', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1    
    const response = await axios.post(apiLink('getServiceEmployeeRoles'), params)    
    
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }
})
export const addServiceEmployeeRole = createAsyncThunk('appServiceEmployee/addServiceEmployeeRole', async (data) => {
    const response = await axios.post(apiLink('addServiceEmployeeRole'), data)
    return response.data
})
export const updateServiceEmployeeRole = createAsyncThunk('appServiceEmployee/updateServiceEmployeeRole', async (data) => {
    const response = await axios.put(apiLink({name: 'updateServiceEmployeeRole', value: data.id}), data)
    return response.data
})
export const removeServiceEmployeeRole = createAsyncThunk('appServiceEmployee/removeServiceEmployeeRole', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeServiceEmployeeRole', value: id}))
    return response.data
})

// ** Employee skills
export const getServiceEmployeeSkills = createAsyncThunk('appServiceEmployee/getServiceEmployeeSkills', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1    
    const response = await axios.post(apiLink('getServiceEmployeeSkills'), params)    
    
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }
})
export const addServiceEmployeeSkills = createAsyncThunk('appServiceEmployee/addServiceEmployeeSkills', async (data) => {
    const response = await axios.post(apiLink('addServiceEmployeeSkills'), data)
    return response.data
})
export const updateServiceEmployeeSkill = createAsyncThunk('appServiceEmployee/updateServiceEmployeeSkill', async (data) => {
    const response = await axios.put(apiLink({name: 'updateServiceEmployeeSkill', value: data.id}), data)
    return response.data
})
export const removeServiceEmployeeSkill = createAsyncThunk('appServiceEmployee/removeServiceEmployeeSkill', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeServiceEmployeeSkill', value: id}))
    return response.data
})

// ** Payments
export const addEmployeePayment = createAsyncThunk('appServiceEmployee/addEmployeePayment', async (data) => {
    return await axios.post(apiLink('addPayment'), data)
})
export const removeEmployeePayment = createAsyncThunk('appServiceEmployee/removeEmployeePayment', async (id) => {
    const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'SERVICE_STATION_EMPLOYEE_SALARY'}))
    return response.data
})

// ** Income
export const getEmployeeIncome = createAsyncThunk('appServiceEmployee/getEmployeeIncome', async data => {   
    const response = await axios.post(`https://api.mfauto.com.ua/repair/employee-income?env=${process.env.REACT_APP_NODE_ENV}`, data)
    return response.data
 })


export const appServiceEmployeeSlice = createSlice({
    name: 'appServiceEmployee',
    initialState: {
        employees: [],        
        total: 1,
        params: {},
        settings: [],
        selectedEmployees: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getServiceEmployeesList.fulfilled, (state, action) => {
            state.employees = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })            
    }
})

export default appServiceEmployeeSlice.reducer